import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const TextFieldToBlock: FieldToBlock<
  'text',
  WorkflowStepFormFieldInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'input',
  componentProps: {
    disabled: field.disabled ?? false,
    size: 'sm',
  },
});

type TextFieldValueProps = FieldValueProps<'text'>;

export const TextFieldValue: FC<TextFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
